import tokenKeeper from '@/lib/apiTokenKeeper';

export const getCompanyId = (): string | undefined => tokenKeeper.getCompany() ?? undefined;
